import { memo, useEffect } from "react";
import { Grid, Box, TextField, FormControl, InputLabel, MenuItem, Button, Select } from '@mui/material';
import { updatePayment } from "services/payments";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useSnackbar } from "notistack";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

export const paymentModes = [
  { name: 'Card', value: 'CARD'},
  { name: 'Cash', value: 'CASH'},
  { name: 'Cheque', value: 'CHEQUE'},
  { name: 'NEFT/IMPS', value: 'NEFT_IMPS'},
  { name: 'UPI', value: 'UPI'},
  { name: 'Online', value: 'ONLINE'},
]

const PaymentUpdate = ({paymentId, onPaymentUpdated, data}) => {

  const defaultFormFields = {
    refNo: '',
    comments: '',
    bankName: '',
    paymentMode: '',
    paymentDate: new Date()
  };
  const { enqueueSnackbar } = useSnackbar();
  // const [paymentData, setPaymentData] = useState({ ...defaultFormFields });
  // const [dateValue, setDateValue] = useState(new Date());

  // const handleDateChange = (newValue) => {
  //   setDateValue(newValue);
  // };

  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  useEffect(() => {
    reset({...data,
      paymentDate: data.paymentDate ? parse(data.paymentDate, 'dd-MM-yyyy', new Date()) : new Date()
    })
  }, [data, reset])

  const onSubmit = (data) => {
    updatePaymentData(data);
  }

  function updatePaymentData(data) {
    updatePayment({...data, paymentId, paymentDate: format(data.paymentDate, 'dd-MM-yyyy')}).then(({error}) =>{
      if(error){
        enqueueSnackbar((error?.message || error), {variant: 'error'});
      } else {
        reset({...defaultFormFields});
        enqueueSnackbar(('Payment details updated successfuly'), {variant: 'success'});
        onPaymentUpdated();
      }
    });
  }
  
  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={1} justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={12}  >
          <FormControl  size="small" fullWidth sx={{ minWidth: 120, }} 
            required
            error={errors.paymentMode?.type === 'required'}
          >
            <InputLabel id="payment-mode-label" >Payment Mode</InputLabel>
            <Controller
            required
            control={control}
            name="paymentMode"
            id="paymentMode"
            rules={{ required: "Select payment mode" }}
            render={({field }) => (
              <Select
                {...field}
                required
                labelId="payment-mode-label"
                // value={issueData.type}
                label="Payment Mode"
              >
                {paymentModes.map(mode => <MenuItem value={mode.value}>{mode.name}</MenuItem>)}
              </Select>
            )}
          />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 2.5}}>
          <Controller
            control={control}
            name="paymentDate"
            id="payment_date"
            rules={{ required: "Select payment data" }}
            render={({field}) => ( 
              <LocalizationProvider dateAdapter={AdapterDateFns} >
                <DatePicker
                  // {...field}
                  label="Payment Date"
                  format="dd-MM-yyyy"
                  inputFormat="dd-MM-yyyy"
                  clearable={false}
                  maxDate={new Date()}
                  value={field.value || new Date()}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  required
                  renderInput={(params) => <TextField required {...field} {...params} size="small" sx={{width: '100%'}} error={errors.paymentDate?.type === 'required'}/>}
                  slotProps={{textField: { fullWidth: true, size: 'small'}}}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}  >
          <Controller
            control={control}
            name="refNo"
            id="ref_no"
            render={({field }) => (
              <TextField
                {...field}
                margin="normal"
                fullWidth
                size="small"
                autoFocus
                label="Reference Number"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} >
          <Controller
            control={control}
            name="bankName"
            id="bank_name"
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Bank Name"
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} >
          <Controller
            control={control}
            name="comments"
            id="comments"
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Comments"
                multiline
                minRows={2}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>
        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          // startIcon={<EditIcon />}
          color="success"
        >
          Submit
        </Button>
      </Grid>
    </Box>
  )
}
 
export default memo(PaymentUpdate);